import { CoreIcon } from '../core-icon';
import navigateCircleColorSVG from '../../assets/icons/navigate-circle-color.svg';
import type { IconProps } from '../core-icon';

export const NavigateCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={navigateCircleColorSVG} {...props} />;
};
